import React, { useState } from "react";
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import Accordion from 'react-bootstrap/Accordion';
import res from "./Res.js"
// Removed GLobalLinks
const Resources = (props) => {
  const [activeKey, setActiveKey] = useState("0-0");
  const resdata = Object.values(res);

  return (
    <>
    <Header en="/partner/resources" fr="/fr" lang="en" />
    <div className="container mainDiv resources">
      <div className="row">
        <div className="col-xs-12 content">
          <h1 className="resources">Resources</h1>
          <div>
            <div className="row">
              <div className="col-lg-8">
                <h2>Welcome to our Partner Resource Page</h2>
                <p>Use the left-hand-side navigation bar to quickly access complete policy wordings, rate charts, steps to selling guides, links to useful webpages, and more!<br />If you have any questions, our Support Services Team is available to assist you Monday – Friday 9:00 a.m. – 7:00 p.m. (ET). Call 1-855-566-8555, email info@travelance.ca or use the live chat feature in the bottom right hand corner of your screen.</p>
                <h2>Products</h2>
                {
                  resdata.map((item,i)=>{
                    return(
                      <div key={i}>
                        <h2>{item.title}</h2>
                        <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
                        {
                          item.accordian.map((accord,j)=>{
                            const eventKey = `${i}-${j}`;
                            return(
                              <Accordion.Item eventKey={eventKey} key={eventKey} id={eventKey} className={activeKey === `${eventKey}` ? `${eventKey} show` : `${eventKey}`}>
                                <Accordion.Header>{accord.title}</Accordion.Header>
                                <Accordion.Body dangerouslySetInnerHTML={{__html:accord.body}} >
                                </Accordion.Body>
                              </Accordion.Item>
                            )
                          })
                        }
                        </Accordion>
                      </div>
                    );
                  })
                }
              </div>
              <div className="col-lg-4">
                <div className="stickyDiv">
                  <div className="holder_block">
                    <h2>Products</h2>
                    <ul className="list">
                      <li><a href="/products" rel="noopener noreferrer">All Products</a></li>
                      <li><a href="/products/visitors-canada-insurance/">VTC</a></li>
                      <li><a href="/products/trips/">TRIPs</a></li>
                      <li><a href="/products/student-accident-plan/">SAP</a></li>
                      <li><a href="/products/international-student/">ISP</a></li>
                    </ul>
                  </div>
                  <div className="holder_block">
                    <h2>Quick Links</h2>
                    <ul className="list">
                      <li><a href="/claims/">Claims</a></li>
                      <li><a href="https://www.getreliable.com/getreliable/">Online Portal Login</a></li>
                      <li><a href="/about-our-underwriter/">Our Underwriter</a></li>
                      <li><a href="/#faqSection">FAQs</a></li>
                      <li><a href="/partner/online-training-sessions/">Register for Online Training</a></li>
                      <li><a href="https://www.travel.gc.ca/travelling/advisories/">Travel Advisories</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer lang="en" />
    </>
  );
}

export default Resources;
